import {Pipe, PipeTransform} from '@angular/core';
import {ToolsService} from '../services/tools.service';

@Pipe({
    name: 'userLevel'
})
export class UserLevelPipe implements PipeTransform {
    constructor(private toolsService: ToolsService) {}

    transform(level: number): any {
        const user_levels = this.toolsService.getUserLevelOptions();
        return user_levels.filter(user_level => +user_level.value === +level)[0].label;
    }
}
